import { useMemo } from 'react';

import type { Volume } from '~/shared/types/api';

interface UseFilteredVolumesParams {
  volumes: Volume[];
  selectedVolumeType: 'supported' | 'notSupported';
  searchQuery: string;
}

export function useFilteredVolumes({
  volumes,
  selectedVolumeType,
  searchQuery,
}: UseFilteredVolumesParams) {
  return useMemo(() => {
    if (!searchQuery.trim()) {
      return volumes;
    }

    const query = searchQuery.toLowerCase();
    return volumes.filter((volume) => {
      return (
        volume.volumeId?.toLowerCase().includes(query) ||
        volume.instanceId?.toLowerCase().includes(query) ||
        volume.clusterName?.toLowerCase().includes(query) ||
        volume.nodeGroupName?.toLowerCase().includes(query) ||
        volume.tags?.some(
          (tag) =>
            tag.key?.toLowerCase().includes(query) || tag.value?.toLowerCase().includes(query)
        )
      );
    });
  }, [volumes, selectedVolumeType, searchQuery]);
}
